module.exports = __webpack_public_path__ + "highlights-logo-4dd834e5f00a986fb93d2801ea51225e.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/logos/highlights-logo.svg
// module id = 1897
// module chunks = 3 6